import { lazyNamed } from 'src/utils/lazyNamed';
import { EmailDesignFormSearchParams } from './pages/EmailDesignForm/types';
import { EmailTemplateFormSearchParams } from './pages/EmailTemplateForm/types';
import { PDFStylesFormSearchParams } from './pages/PDFStylesForm/types';

export const CompanySettings = {
  // common
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  SalesUnitsProvider: lazyNamed(() => import('./components/SalesUnitsProvider'), 'SalesUnitsProvider'),

  // pages
  CoopWeeks: lazyNamed(() => import('./pages/CoopWeeks'), 'CoopWeeks'),
  EmailTemplateForm: lazyNamed(() => import('./pages/EmailTemplateForm'), 'EmailTemplateForm'),
  EmailTemplates: lazyNamed(() => import('./pages/EmailTemplates'), 'EmailTemplates'),
  EmailDesigns: lazyNamed(() => import('./pages/EmailDesigns'), 'EmailDesigns'),
  EmailDesignForm: lazyNamed(() => import('./pages/EmailDesignForm'), 'EmailDesignForm'),
  PaymentDetails: lazyNamed(() => import('./pages/PaymentDetails'), 'PaymentDetails'),
  PaymentDetailsForm: lazyNamed(() => import('./pages/PaymentDetailsForm'), 'PaymentDetailsForm'),
  PDFFooterTemplates: lazyNamed(() => import('./pages/PDFFooterTemplates'), 'PDFFooterTemplates'),
  PDFStylesForm: lazyNamed(() => import('./pages/PDFStylesForm'), 'PDFStylesForm'),
  PDFStyles: lazyNamed(() => import('./pages/PDFStyles'), 'PDFStyles'),
  PDFTypeConfigurations: lazyNamed(() => import('./pages/PDFTypeConfigurations'), 'PDFTypeConfigurations'),
  PPTReportConfig: lazyNamed(() => import('./pages/PPTReportConfig'), 'PPTReportConfig'),
  Sequencing: lazyNamed(() => import('./pages/Sequencing'), 'Sequencing'),
  UserIdModules: lazyNamed(() => import('./pages/UserIdModules'), 'UserIdModules'),

  // search params
  EmailTemplateFormSearchParams,
  EmailDesignFormSearchParams,
  PDFStylesFormSearchParams,
};
